import {v4 as uuidv4} from 'uuid';

export class Attendee {
  constructor() {
    this.id = uuidv4();
    this.firstName = '';
    this.lastName = '';
    this.email = '';

    return this;
  }

  map(attendee) {
    this.id = attendee.id;
    this.firstName = attendee.first_name;
    this.lastName = attendee.last_name;
    this.email = attendee.email;

    return this;
  }

  update(attendee) {
    if (attendee.id) this.id = attendee.id;
    if (attendee.firstName) this.firstName = attendee.first_name;
    if (attendee.lastName) this.lastName = attendee.last_name;
    if (attendee.email) this.email = attendee.email;

    return this;
  }
}
